import { useCallback, useMemo } from 'react';
import useSWR from 'swr';

import { GridColDef } from '@mui/x-data-grid-pro';
import { gridDateTimeFormatter, openFile } from '@shared/commonFunctions';
import { dataGridCol } from '@shared/components/grid/common';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { SERVICES } from '@shared/constants/apiConfig';
import { Link, Wrapper } from '@styles/CommonStyles';

import { requestGetShipmentFileData } from '../ReadytoShip/requests';
import { IShipmentBatch } from './types';

export const ActiveShipment = () => {
  const { data: shipments } = useSWR<IShipmentBatch[]>(`${SERVICES.DOCUMENT}/shipmentBatch`);

  const onNumberClick = useCallback(async (blobPath: string) => {
    const res = await requestGetShipmentFileData(blobPath);
    openFile(res?.data?.document, 'pdf', res?.data?.fileName);
  }, []);

  const columns: GridColDef[] = useMemo(() => [
    dataGridCol('createdDate', {
      headerName: 'Date',
      flex: 1,
      minWidth: 100,
      type: 'dateTime',
      valueFormatter: gridDateTimeFormatter,
    }),
    dataGridCol('batchNumericId', {
      headerName: 'Batch Id',
      flex: 0.5,
      minWidth: 50,
    }),
    dataGridCol('nameTo', {
      headerName: 'To',
      flex: 2,
      minWidth: 100,
    }),
    dataGridCol('totalDeals', {
      headerName: 'Totals',
      flex: 1,
      minWidth: 100,
    }),
    dataGridCol('trackingStatusIn', {
      headerName: 'Status',
      flex: 1,
      minWidth: 100,
    }),
    dataGridCol('trackingNumberOut', {
      headerName: 'Out',
      flex: 1.2,
      minWidth: 200,
      renderCell: (params) => (
        <Link target="_blank" onClick={() => onNumberClick(params.row?.outBlobFileId)}>
          {params.row.trackingNumberOut}
        </Link>
      ),
    }),
    dataGridCol('trackingNumberIn', {
      headerName: 'In',
      flex: 1.2,
      minWidth: 200,
      renderCell: (params) => (
        <Link target="_blank" onClick={() => onNumberClick(params.row?.inBlobFileId)}>
          {params.row.trackingNumberIn}
        </Link>
      ),
    }),
  ], []);

  return (
    <Wrapper>
      <PhoenixGrid
        autoHeight
        noButton
        withHeader
        strict
        showClearAllFilter
        name="Active Shipments"
        pageSize={15}
        columns={columns}
        loading={!shipments}
        rows={shipments || []}
        getRowId={(row) => row.shipmentBatchId}
      />
    </Wrapper>
  );
};
